import { useIntl } from 'react-intl'
import { formatValueByBase, getNumberBase } from './helpers'
import cx from 'classnames'
import _ from 'lodash'

import './NumberFormatter.scss'

const renderUnformattedValue = (value, emptyValue) => {
    return value ?? emptyValue
}

// TODO: Add info about component (Marek Prantl)

const NumberFormatter = ({
    customBase,
    value,
    currency,
    decimalPlaces = 2,
    formatValue = true,
    showUnits = false,
    showCurrency = false,
    emptyValue = '-',
    displayNegativesRed = false,
    valueStyle,
    currencyStyle,
    unitsStyle,
}) => {
    const intl = useIntl()

    // For no value return empty value
    if (_.isNil(value)) return emptyValue

    // Get base for input value - thousands, millions, etc.
    let base = getNumberBase(value)
    if (!_.isNil(customBase) && typeof customBase === 'number') base = getNumberBase(customBase)
    if (!_.isNil(customBase) && typeof customBase === 'object') base = customBase

    return (
        <span className={cx(displayNegativesRed && value < 0 && 'negative-value')}>
            <span className={'value'} style={{ ...valueStyle }}>
                {formatValue
                    ? formatValueByBase(value, base?.base, decimalPlaces, emptyValue)
                    : renderUnformattedValue(value, emptyValue)}
            </span>
            {showUnits && base?.translate && (
                <span className={'units'} style={{ ...unitsStyle }}>
                    {intl.formatMessage({ id: `global.units.${_.toLower(base?.translate)}`, defaultMessage: ' ' })}
                </span>
            )}
            {showCurrency && (
                <span className={'currency'} style={{ ...currencyStyle }}>
                    {intl.formatMessage({ id: `global.currency.${_.toLower(currency)}`, defaultMessage: ' ' })}
                </span>
            )}
        </span>
    )
}

export default NumberFormatter
